import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { IMG } from "@/lib/images";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export const Thoughtful = () => {
  const { t } = useLang();
  return (
    <section
      id="thoughtful"
      data-testid="thoughtful-section"
      className="relative py-28 md:py-40 bg-forest text-ivory overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-40" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center"
        >
          <motion.div variants={fadeUp} className="lg:col-span-5">
            <p className="overline text-bronze mb-6">{t.thoughtful.eyebrow}</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight">
              {t.thoughtful.title}
            </h2>
            <div className="mt-8 text-base md:text-lg leading-relaxed text-ivory/80 space-y-6 max-w-md">
              <p>{t.thoughtful.body_1}</p>
              <p>{t.thoughtful.body_2}</p>
              <p className="font-serif italic text-xl md:text-2xl text-ivory/95 leading-snug">
                {t.thoughtful.body_3}
              </p>
            </div>
          </motion.div>
          <motion.div variants={fadeUp} className="lg:col-span-6 lg:col-start-7">
            <div className="aspect-[4/5] w-full overflow-hidden border border-ivory/15">
              <img
                src={IMG.cabinInterior}
                alt="Thoughtful architecture"
                className="w-full h-full object-cover hover-img"
              />
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
